<template>
	<v-dialog v-model="dialog" persistent max-width="800" scrollable>
		<v-card v-if="terms">
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-13 cl-primary text-capitalize">{{ terms.title }}</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<div class="d-block py-4 dark--text">
					<h3 class="mb-4">POIN POIN PERATURAN :</h3>
					<p class="d-flex flex-row mb-1"><span>01.</span><span class="pl-2">Adanya biaya Registrasi ulang tahunan sesuai Tanggal Gabung dengan cara membeli Paket RO Pembaruan ID</span></p>
					<p class="d-flex flex-row mb-1"><span>02.</span><span class="pl-2">Yang tidak Registrasi Ulang penambahan jaringan (BV) tdk dihitung</span></p>
					<p class="d-flex flex-row mb-1"><span>03.</span><span class="pl-2">Satu ID(SATU NAMA) bisa memiliki beberapa titik Tracking Center dalam satu pohon</span></p>
					<p class="d-flex flex-row mb-1"><span>04.</span><span class="pl-2">Tidak boleh jual beli ID dan Balik nama hanya bisa kepada Ahli Waris yg tercantum di VO</span></p>
					<p class="d-flex flex-row mb-1"><span>05.</span><span class="pl-2">Nomor Rekening harus sama dgn nama ID jika tidak maka komisi akan di-pending</span></p>
					<p class="d-flex flex-row mb-1"><span>06.</span><span class="pl-2">Pemblokiran dan Penghapusan ID bisa dilakukan oleh Perusahaan bila customer melanggar:</span></p>
						<p class="d-flex flex-row mb-1 pl-7"><span>-</span><span class="pl-2">Memakai uang / Produk customer lain</span></p>
						<p class="d-flex flex-row mb-1 pl-7"><span>-</span><span class="pl-2">Memanipulasi ID orang Lain </span></p>
						<p class="d-flex flex-row mb-1 pl-7"><span>-</span><span class="pl-2">Mencemarkan nama baik Perusahaan</span></p>
						<p class="d-flex flex-row mb-1 pl-7"><span>-</span><span class="pl-2">SKKB</span></p>
					<p class="d-flex flex-row mb-1"><span>07.</span><span class="pl-2">Untuk pengembangan siapa yang dapat/mengundang/menjelaskan selam waktu 30 hari menjadi haknya.</span></p>
					<p class="d-flex flex-row mb-1"><span>08.</span><span class="pl-2">Customer akan mendapatkan Perlindungan/Asuransi Keselamatan kerja di 3 Bulan Pertama Gabung selanjutnya bisa diperpanjang dengan membeli RO Bulanan</span></p>
					<p class="d-flex flex-row mb-1"><span>09.</span><span class="pl-2">Customer yang Wajib menyerakan Foto/File ke Admin untuk pembuatan KTA</span></p>
					<p class="d-flex flex-row mb-1"><span>10.</span><span class="pl-2">Customer Harus mempunyai Rek Bank an Pribadi (Bank BUMN BRI/Mandiri/BNI)</span></p>
					<p class="d-flex flex-row mb-1"><span>11.</span><span class="pl-2">Bila customer melakukan Hal/Tindakan melawan/Melanggar hukum dalam menjalankan pengembangan Jaringan maka itu Tanggung jawab pribadi dan tidak melibatkan dan menyakut pautkan Up Line/Leder/Perusahaan PT.DSN</span></p>
					<p class="d-flex flex-row mb-1"><span>12.</span><span class="pl-2">Tentang akun saya:</span></p>
						<p class="d-flex flex-row mb-1 pl-7"><span>-</span><span class="pl-2">Perubahan Alamat/Sandi/E-mail/Nomor HP</span></p>
						<p class="d-flex flex-row mb-1 pl-7"><span>-</span><span class="pl-2">Koreksi Nama/Rek/No HP</span></p>
					<p class="d-flex flex-row mb-1"><span>13.</span><span class="pl-2">Pengiriman dan Pengantaran Barang oleh perusahaan kerjasama dengan PT. POS INDONESIA</span></p>
					<p class="d-flex flex-row mb-1"><span>14.</span><span class="pl-2">Pendaftaran dan Keanggotaan secara online melalui VO.</span></p>
					<p class="d-flex flex-row mb-1"><span>15.</span><span class="pl-2">Angota/customer boleh melakukan Pengunduran diri</span></p>
					<p>&nbsp;</p>
					<h3 class="mb-3">Agreement:</h3>
					<p class="d-flex flex-row mb-1"><span>@</span><span class="pl-2">Bahwa saya sudah mengerti dan memahami bagaimana Peraturan etika, cara kerja,sistem dan pembagian komisi/ujroh PT. DSN</span></p>
					<p class="d-flex flex-row mb-1"><span>@</span><span class="pl-2">Bahwa saya sudah mengerti manfaat produk yang saya beli dari PT.DSN</span></p>
					<p class="d-flex flex-row mb-1"><span>@</span><span class="pl-2">Bahwa saya menjadi mitra dan membeli produk PT. DSN tidak ada paksaan tapi kesadaran sendiri</span></p>
				</div>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="3">
					<v-btn depressed block color="primary" class="white--text rounded-lg text-capitalize" @click="modalHide">
						<v-icon small v-if="false">mdi-close</v-icon>
						<span>Tutup</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	data () {
		return {
			dialog: false,
		}
	},
	computed: {
	},
	props: ['terms'],
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
	}
};
</script>